import PropTypes from 'prop-types';
import React from 'react';

const ReservationError = ({ error }) => (
  <div className="layout layout--large u-mt++">
    <div className="layout__item u-text-center">
      <div className="c-heading--large">
        { error }
      </div>
    </div>
  </div>
);
ReservationError.propTypes = {
  error: PropTypes.string.isRequired,
};

export default ReservationError;



// WEBPACK FOOTER //
// ./src/app/reservation/components/ReservationError.jsx